module.exports = __webpack_public_path__ + "img/continue-button.0051d8ad.png";